import { COLORS } from 'constants/colors';
import { PageWrapper } from 'styles';
import { Header } from 'components/Header';
import { HomeContent } from 'components/HomeContent';
import { useEffect, useState } from 'react';
import { AboutContent } from 'components/AboutContent';
import { useDimensions } from 'hooks/useDimensions';

const App = () => {
  const [content, setContent] = useState('home');
  const [changing, setChanging] = useState(false);
  const { isSmallWidth } = useDimensions();

  const { height } = useDimensions();

  useEffect(() => {
    if (changing) {
      setTimeout(() => setChanging(false), 500);
    }
  }, [changing]);

  return (
    <>
      <PageWrapper color={COLORS.black} style={{ padding: isSmallWidth ? 30 : 60, height }}>
        <div style={{ transition: '0.5s', opacity: changing ? 0 : 1, display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          {content === 'home' && <HomeContent />}
          {content === 'about' && <AboutContent />}
        </div>
        <div
          style={{
            display: 'flex',
            height: 75,
            justifyContent: isSmallWidth ? 'space-between' : 'center',
            position: 'absolute',
            right: isSmallWidth ? 30 : 60,
            width: isSmallWidth ? 'calc(100% - 60px)' : 'auto',
          }}
        >
          <Header
            onChangeContent={(contentSelected) => {
              if (content !== contentSelected && !changing) {
                setChanging(true);
                setTimeout(() => setContent(contentSelected), 500);
              }
            }}
          />
        </div>
      </PageWrapper>
    </>
  );
};

export default App;
